<template>
  <div id="app">
    <KoIKO />
  </div>
</template>

<script>
import KoIKO from "../../components/KoIKO";

export default {
  name: 'app',
  components: {
    KoIKO,
  }
}
</script>
